export default function ProductSelector({ products, grid, setGrid }) {
  return (
    <div className="product-selector">
      <div className="products">
        {products.map((product) => (
          <button
            key={product.id}
            type="button"
            onClick={() => setGrid(product)}
            className={grid.id === product.id ? "active" : ""}
          >
            <span>{product.name || product.label}</span>

            {product.price && (
              <strong>{product.price.toFixed(2)} EUR</strong>
            )}
          </button>
        ))}
      </div>

      <p className="selected-grid">
        Modelo seleccionado: <strong>{grid.cols} x {grid.rows}</strong>
      </p>
    </div>
  );
}
